import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Modal, Form, Button } from '_zari/core'

import * as glosasService from 'services/glosasContabilidad.service'

import * as FormGroups from './formGroups'

const EditarGlosaModal = ({ handleClose, show, reloadTable, modalData }) => {
  const __zariContext = React.useContext(ZariContext)

  const submitHandler = async data => {
    await glosasService
      .actualizar(modalData._id, data)
      .then(() => {
        __zariContext.snack('success', 'El registro se ha actualizado.')
        reloadTable()
        handleClose()
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }

  const formInitialValues = React.useMemo(
    () => ({
      nombre: modalData.nombre || ''
    }),
    [modalData]
  )

  return (
    <Modal show={show} onHide={handleClose} size='sm'>
      <Modal.Header>
        <Modal.Title>EDITAR GLOSA</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler}>
        {({ errors, handleSubmit, isSubmitting, touched }) => (
          <Form>
            <Modal.Body>
              <FormGroups.NombreFormGroup
                iError={errors.nombre}
                iTouched={touched.nombre}
                fIsSubmitting={isSubmitting}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit}>Actualizar</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default EditarGlosaModal
